/**
 * Gera um valor aleatório único combinando um número randômico com o timestamp atual.
 * Utilizado para forçar a re-renderização de componentes React quando necessário.
 */
export const getRandomValueToForceRerender = () => Math.random() + new Date().getTime();